import React from "react";
import {autobind} from "core-decorators";
import {action, observable} from "mobx";
import {inject, observer} from "mobx-react";
import {Typography} from "antd";

import {EnsembleNameChange, EnsembleNameChangeVariables} from "@/graphql/types";
import EnsembleNameChangeNode from "./EnsembleNameChange.gql";
import Store from "@/stores";

export interface IEnsembleNameProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class EnsembleName extends React.Component<IEnsembleNameProps> {
  @observable name = this.props.store!.session.selectedEnsemble!.name;

  // Restore name from the database
  restoreName() {
    this.setName(this.props.store!.session.selectedEnsemble!.name);
  }

  // Save name to database
  async saveName() {
    const {apollo, session} = this.props.store!;
    const previousName = session.selectedEnsemble!.name;
    if (this.name === previousName) return;
    session.setSelectedEnsembleName(this.name); // optimistic UI update
    try {
      const result = await apollo.client.mutate<EnsembleNameChange, EnsembleNameChangeVariables>({
        mutation: EnsembleNameChangeNode,
        variables: {
          ensembleId: session.selectedEnsemble!.id,
          name: this.name,
        },
      });
      const updatedEnsemble = result.data?.ensemble;
      if (!updatedEnsemble) throw new Error("Could not update Ensemble's name");
      session.setSelectedEnsembleName(updatedEnsemble.name);
    } catch (error) {
      session.setSelectedEnsembleName(previousName);
      console.error(error);
    }
  }

  @action
  setName(name: string) {
    this.name = name;
  }

  public render() {
    return (
      // Save the name when edit looses focus
      // https://reactjs.org/docs/events.html#detecting-focus-entering-and-leaving
      <span onBlur={this.saveName}>
        <Typography.Text editable={{onChange: this.setName, onEnd: this.saveName, onCancel: this.restoreName}}>
          {this.name}
        </Typography.Text>
      </span>
    );
  }
}
